
// src/connects/attachments-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import filter from 'lodash/filter'

function isImage(file) {
  return file.content_type.match(/^image/)
}

function isVideo(file) {
  return file.content_type.match(/^video/) && (file.file_id || file.status == 'committed')
}

export const mapStateToProps = (state, ownProps)=> {
  const items = state.attachments.items
  return {
    isFetching: state.attachments.isFetching,
    isFetchFailed: state.attachments.isFetchFailed,
    files: items,
    images: items && filter(items, isImage) || undefined,
    videos: items && filter(items, isVideo) || undefined,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: ()=> {
      if (ownProps.params.comment_id) {
        ownProps.params.comment_id && dispatch(actions.fetchCommentAttachments(ownProps.params.comment_id))
      }
      else {
        ownProps.params.diary_id && dispatch(actions.fetchDiaryAttachments(ownProps.params.diary_id))
      }
    },

    willUpdate: (props, nextProps)=> {
      if (nextProps.params.comment_id && props.params.comment_id != nextProps.params.comment_id)
        dispatch(actions.fetchCommentAttachments(nextProps.params.comment_id))
      else if (nextProps.params.diary_id && (props.params.diary_id != nextProps.params.diary_id ||
        props.params.comment_id && !nextProps.params.comment_id))
        //コメントの添付ファイルを表示後、同じdiary_idの日報の添付ファイルをクリックした場合、nextProps.params.comment_id = undefined となる
        dispatch(actions.fetchDiaryAttachments(nextProps.params.diary_id))
    },

    willUnmount: ()=> dispatch(actions.clearAttachments()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  context({ showImagesView: PropTypes.func }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/attachments-page.js